/* eslint-disable */

export default function debounce(
  func: Function,
  wait: number,
  immediate?: boolean,
): Function {
  let timeout: NodeJS.Timeout | null;

  return function executedFunction() {
    // @ts-ignore
    const context = this;
    const args = arguments;

    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && !timeout;

    if (timeout !== null) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}
